/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/4g4b5dg/screen/61233374
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import originalMoment from 'moment';
import { extendMoment } from 'moment-range';
import contains from 'ramda/src/contains';
import filter from 'ramda/src/filter';
import isNil from 'ramda/src/isNil';
import isEmpty from 'ramda/src/isEmpty';
import length from 'ramda/src/length';
import slice from 'ramda/src/slice';
import Avatar from '@components/@core/Avatar';
import DatePicker from '@components/@core/DatePicker';
import EditDropdown from '@components/EditDropdown';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Filter from '@components/@core/Filter';
import Icon from '@components/@core/Icon';
import Pagination from '@components/@core/Pagination';
import AppActions from '~/actions/app';
import CommunityActions from '~/actions/community';
import ManageActions from '~/actions/manage';
import { ReportMenu } from '~/services/config';
import { exportCsv } from '~/services/util-excel';
import withNavigate from '~/hocs/withNavigate';
import { AnniversaryPdf } from './AnniversaryPdf';
const moment = extendMoment(originalMoment);
const today = moment();

class Anniversary extends Component {
    state = {
        date: moment.range(today.clone(), today.clone().add(1, 'year')),
        currentPage: 1,
        perPage: 25,
        company: this.props.company,
        user: [],
        base: 'anniversary',
        orderBy: 'name',
        asc: true,
        month_start: '01',
        month_end: '12',
    };

    componentDidMount() {
        const { companyIds } = this.props;
        const { base, asc, orderBy, month_start, month_end } = this.state;
        this.handleFetchAnniversary(companyIds[0], base, orderBy, asc, month_start, month_end);
    }

    handleFetchAnniversary(companyId, base, order_by, asc, month_start, month_end) {
        const payload = { order_by, order: asc ? 'ASC' : 'DESC', month_start, month_end };
        this.props.getAnniversaryReports(companyId, base, payload);
        this.setState({ orderBy: order_by, asc: !asc });
    }

    handleFilter = (type, e) => {
        const { base, asc, orderBy, month_start, month_end } = this.state;

        if (isNil(e)) return;
        if (type === 'company') {
            const company = e[0].id < 0 ? this.state.company : e[0];
            this.handleFetchAnniversary(company.id, base, orderBy, asc, month_start, month_end);
            this.setState({ company });
        } else if (type === 'employee') {
            const user = e.map((item) => item.id);
            this.setState({ user });
        }
    };

    handleDate = (e) => {
        const { company, base, asc, orderBy } = this.state;
        const date = moment.range(moment(e.start).format('MM/DD/YYYY'), moment(e.end).format('MM/DD/YYYY'));
        const month_start = date.start.format('MM');
        const month_end = date.end.format('MM');
        this.handleFetchAnniversary(company.id, base, orderBy, asc, month_start, month_end);
        this.setState({ date, month_start, month_end });
    };

    handleSort = (event) => {
        const { base, asc, company, month_start, month_end } = this.state;
        this.handleFetchAnniversary(company.id, base, event, asc, month_start, month_end);
    };

    handleMenu = (e) => {
        const payload = { userId: e.community_user_id };
        this.props.getUser(payload, `/${e.community_user.entity.slug}/about?user_id=${e.community_user_id}`);
    };

    handleExcelReport = () => {
        this.props.toggleModal({
            type: 'Confirm',
            data: {
                before: {
                    title: 'Confirm',
                    body: 'Would you like to download this reports data to excel?',
                },
            },
            callBack: {
                onYes: () => {
                    this.handleExcel();
                },
            },
        });
    };

    handleExcel = () => {
        const { anniversaryReport } = this.props;

        const employees = isEmpty(anniversaryReport.active) ? [] : anniversaryReport.active.employees;
        let anniversary = [];
        employees.forEach((employee) => {
            const excelData = {
                Name: employee.name,
                Company: employee.company_name,
                Departments: employee.department_name,
                'Anniversary Date': isNil(employee.anniversary_date) || isEmpty(employee.anniversary_date) ? 'NA' : moment(employee.anniversary_date).format('MMM DD, YYYY'),
                'Hire Date': moment(employee.hired_at).format('MMM DD, YYYY'),
            };
            anniversary.push(excelData);
        });

        const key = ['Name', 'Company', 'Departments', 'Anniversary Date', 'Hire Date'];
        exportCsv(anniversary, key, 'Reports-Anniversary', true);
    };

    handleSelectMenu = (e) => {
        switch (e) {
            case 'export':
                this.handleExcelReport();
                break;
            case 'print': {
                const { date, currentPage, perPage } = this.state;
                const { anniversaryReport } = this.props;
                const activeEmployee = isEmpty(anniversaryReport.active) ? [] : anniversaryReport.active.employees;
                const from = (currentPage - 1) * perPage;
                const to = currentPage * perPage;
                const employees = slice(from, to, activeEmployee);
                AnniversaryPdf({ employees, date });
                break;
            }
        }
    };

    render() {
        const { date, currentPage, perPage, user } = this.state;
        const { anniversaryReport } = this.props;
        const activeEmployee = isEmpty(anniversaryReport.active) ? [] : anniversaryReport.active.employees;
        const filtered = user.length > 0 ? filter((e) => contains(e.id, user), activeEmployee) : activeEmployee;

        const from = (currentPage - 1) * perPage;
        const to = currentPage * perPage;
        const totalPage = Math.ceil(length(filtered) / perPage);
        const selected = slice(from, to, filtered);
        const menu = ['Profile'];

        return (
            <ErrorBoundary className="mng-anniversary">
                <Filter onChange={this.handleFilter} />
                <div className="card">
                    <div className="d-flex ai-center mb-2">
                        <span className="dsl-b22 bold d-flex-1 d-flex-sm-0 lh-sm-16">Anniversary Report</span>
                        <DatePicker calendar="range" append="caret" format="MMM DD, YYYY" as="span" align="right" value={date} onSelect={this.handleDate} />
                        <EditDropdown className="ml-3" dataCy="editDropdown" options={ReportMenu} onChange={this.handleSelectMenu} />
                    </div>
                    <div className="list-header mt-4 desktop-screen">
                        <div className="d-flex d-flex-3 dsl-m12 text-400 cursor-pointer" onClick={() => this.handleSort('name')}>
                            Employee's Name
                            <span className="ml-1 sort-item">
                                <Icon name="fas fa-sort-down caret" color="#343f4b" size={10} />
                            </span>
                        </div>
                        <div className="d-flex-2 dsl-m12 text-400 cursor-pointer" onClick={() => this.handleSort('departments')}>
                            Departments
                            <span className="ml-1 sort-item">
                                <Icon name="fas fa-sort-down caret" color="#343f4b" size={10} />
                            </span>
                        </div>
                        <div className="d-flex-2 dsl-m12 text-end text-400 cursor-pointer" onClick={() => this.handleSort('anniversary_date')}>
                            Anniversary date
                            <span className="ml-1 sort-item">
                                <Icon name="fas fa-sort-down caret" color="#343f4b" size={10} />
                            </span>
                        </div>
                        <div className="d-flex-2 dsl-m12 text-end text-400 cursor-pointer" onClick={() => this.handleSort('hired_at')}>
                            Hire Date
                            <span className="sort-item">
                                <Icon name="fas fa-sort-down caret" color="#343f4b" size={10} />
                            </span>
                        </div>
                        <div className="d-flex-1 dsl-m12" />
                    </div>
                    {selected.map((employee, index) => {
                        const hireDate = moment(employee.hired_at).format('MMM DD, YY');
                        const anniversaryDate = employee.hired_at ? moment(employee.hired_at).format('MMM DD') : 'N/A';

                        return (
                            <div className="list-item cursor-pointer d-flex ssm-column mt-2" key={`anniversary${index}`}>
                                <div className="d-h-between d-flex-3 dsl-m12 w-100">
                                    <div className="d-flex ai-center">
                                        <Avatar name={employee.name} url={employee.profile.avatar} onToggle={() => this.props.navigate(`/library/record-employee-info/${employee.id}`)} />
                                        <span className="dsl-b14 ms-2 text-400 ms-3">{employee.name}</span>
                                    </div>
                                    <EditDropdown className="mobile-screen" options={menu} onChange={() => this.handleMenu(employee)} />
                                </div>
                                <div className="d-flex-2 w-100 ms-0">
                                    <label className="dsl-b14 mobile-screen w-40" onClick={() => this.handleSort('departments')}>
                                        Department
                                    </label>
                                    <span className="dsl-b14 text-400">{employee.department_name}</span>
                                </div>
                                <div className="d-flex-2 text-end ssm-left w-100 ms-0">
                                    <label className="dsl-b14 mobile-screen w-40" onClick={() => this.handleSort('anniversary_date')}>
                                        Anniversary
                                    </label>
                                    <span className="dsl-b14 text-400">{anniversaryDate}</span>
                                </div>
                                <div className="d-flex-2 text-end ssm-left w-100 ms-0">
                                    <label className="dsl-b14 mobile-screen w-40" onClick={() => this.handleSort('hired_at')}>
                                        HireDate
                                    </label>
                                    <span className="dsl-b14 text-400">{hireDate}</span>
                                </div>
                                <div className="d-flex-1 dsl-m12 text-end desktop-screen">
                                    <EditDropdown options={menu} onChange={() => this.handleMenu(employee)} />
                                </div>
                            </div>
                        );
                    })}
                    <Pagination current={currentPage} per={perPage} total={totalPage} onChange={(e) => this.setState({ currentPage: e })} onPer={(e) => this.setState({ perPage: e })} />
                </div>
            </ErrorBoundary>
        );
    }
}

Anniversary.propTypes = {
    userId: PropTypes.number,
    company: PropTypes.shape({ id: PropTypes.number }),
    anniversaryReport: PropTypes.shape({
        active: PropTypes.object,
        prior: PropTypes.object,
        recruit: PropTypes.object,
    }),
    getAnniversaryReports: PropTypes.func,
    toggleModal: PropTypes.func,
};

Anniversary.defaultProps = {
    userId: 0,
    company: { id: 0 },
    userIds: [],
    companyIds: [],
    anniversaryReport: { active: {}, prior: {}, recruit: {} },
    getAnniversaryReports: () => {},
    toggleModal: () => {},
};

const mapStateToProps = (state) => ({
    userId: state.app.id,
    company: state.app.company_info,
    userIds: state.app.selectedEmployee.users,
    companyIds: state.app.selectedCompany,
    anniversaryReport: state.manage.anniversarybirthdayReport,
});

const mapDispatchToProps = (dispatch) => ({
    getAnniversaryReports: (companyId, base, payload) => dispatch(ManageActions.getanniversarybirthdayRequest(companyId, base, payload)),
    getUser: (payload, route) => dispatch(CommunityActions.getcommunityuserRequest(payload, null, route)),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
});

const AnniversaryWithNavigate = withNavigate(Anniversary);
export default connect(mapStateToProps, mapDispatchToProps)(AnniversaryWithNavigate);
